export const investigationStatusStyles = (theme) => ({
  requestedBubble: {
    marginLeft: "10px",
  },
  checkIcon: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "20px",
    padding: "5px",
    color: "#ffffff",
  },
});
